<template>
  <div class="footer-wrapper">
    <div class="footer">
      Copyright © 湖北大学、湖北省教育信息化发展中心
    </div>
  </div>
</template>
<script>
export default {}
</script>
<style lang="less" scoped>
.footer-wrapper {
  width: 100%;
  // margin-top: 50px;
  line-height: 30px;
  background: #282828;
  color: #ababab;
  .footer {
    position: relative;
    max-width: 1180px;
    width: 100%;
    height: 50px;
    margin: 0 auto;
    text-align: center;
    line-height: 50px;
    color: #dedede;
    font-size: 16px;
  }
}
</style>